import React, { useEffect, useState } from "react";
import { Card, Spin, message, Tag, Empty } from "antd";
import axios from "axios";
import SummaryApi from "../common/index";
import "../Styles/UserStylings/MyQueries.css";

const MyQueries = () => {
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchQueries = async () => {
    setLoading(true);
    try {
      const response = await axios.get(SummaryApi.getMyQueries.url, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        withCredentials: true,
      });
      setQueries(response.data?.queries || []);
    } catch (error) {
      message.error("Failed to fetch queries");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchQueries();
  }, []);

  if (loading) {
    return (
      <div className="myqueries-loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="myqueries-container">
      <h2 className="myqueries-title">My Support Queries</h2>
      {queries.length === 0 ? (
        <Empty description="No queries raised yet." />
      ) : (
        <div className="myqueries-grid">
          {queries.map((q) => (
            <Card
              key={q.id}
              className="myqueries-card"
              title={<span className="card-title">{q.subject}</span>}
              bordered={false}
              hoverable
            >
              <p><b>Category:</b> {q.category}</p>
              <p><b>Priority:</b> <Tag color={q.priority === "High" ? "red" : q.priority === "Medium" ? "orange" : "green"}>{q.priority}</Tag></p>
              <p><b>Status:</b> <Tag color={q.status === "Resolved" ? "green" : q.status === "Pending" ? "orange" : "blue"}>{q.status}</Tag></p>
              <p className="desc"><b>Description:</b> {q.description}</p>
              <p className="created"><b>Created:</b> {new Date(q.created_at).toLocaleString()}</p>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyQueries;
